import { Component, OnInit } from '@angular/core';
import { MetaService } from '@app/services/meta.service';
import { SharedModule } from '@app/shared/shared.module';
import { HeroComponent } from "../hero/hero.component";
import { ParallaxStandaloneDirective } from '@yoozly/ngx-parallax';
import { SummaryComponent } from "../summary/summary.component";
import { HomeObituaryComponent } from "../home-obituary/home-obituary.component";

@Component({
	selector: 'app-home',
	standalone: true,
	imports: [
    SharedModule,
    HeroComponent,
    ParallaxStandaloneDirective,
    SummaryComponent,
    HomeObituaryComponent
],
	templateUrl: './home.component.html',
	styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit {

	constructor(
		private meta: MetaService
	) { }

	ngOnInit(): void {
		this.meta.setTitle("");
	}


}
